export default {
  noDiscount: {
    title: {
      en: 'Monthly supply of any listed fragrance starting at {price}',
    },
  },
  discount: {
    title: {
      en: 'Get {discount} off and&#32;<br class="onlyMobile" />a free case',
    },
    text: {
      en: 'Indulge in new designer scents <br />every month for just {price}.',
    },
    note: {
      en: 'Score your first month\nfor just {priceWithDiscount}.',
    },
  },
  freeTrial: {
    title: {
      en: 'Get your free perfume now',
    },
    text: {
      en: 'Indulge in new designer scents every month for just {price}. Your first month is free, just pay {extraShippingPrice} for shipping and handling.',
    },
  },
  freeProduct: {
    title: {
      en: 'Subscribe and unlock a free product in your first order',
    },
    text: {
      en: 'Indulge in new designer scents every month for just {price}.',
    },
  },
  freeMonth: {
    title: {
      en: 'Subscribe today',
    },
    text: {
      en: 'Buy one, get one free! Monthly supply of any listed fragrance starting at {price}.',
    },
  },
  abTest: {
    noDiscount: {
      title: {
        en: 'Monthly supply of any listed fragrance starting at {price}',
      },
    },
    discount: {
      title: {
        en: 'Indulge in<br class="onlyDesktop"/> new designer scents every month',
      },
      text: {
        en: 'Explore a world of fragrance every month for <s>{price}</s> <b>{priceWithDiscount}</b>.',
      },
      note: {
        en: 'Claim your exclusive offer now.',
      },
    },
    freeTrial: {
      title: {
        en: 'Get your free perfume now',
      },
      text: {
        en: 'Indulge in new designer scents every month for just {price}. Your first month is free, just pay {extraShippingPrice} for shipping and handling.',
      },
    },
    freeProduct: {
      title: {
        en: 'Subscribe and unlock a free product in<br class="onlyDesktop"/> your first<br class="onlyDesktop"/> order',
      },
      text: {
        en: 'Indulge in new designer scents every month for just {price}.',
      },
    },
    freeMonth: {
      title: {
        en: 'Indulge in<br class="onlyDesktop"/> new designer scents every month',
      },
      text: {
        en: 'Buy one, get one free! Monthly supply of any listed fragrance starting at {price}.',
      },
    },
  },
}
